import dayjs from 'utils/dayjs';

const getTotalDeductions = (packCalc) => {
    const totalDeductions = packCalc.totalReductions + packCalc.totalCostOfOccupiedRoom;
    return !Number.isNaN(totalDeductions) ? totalDeductions.toFixed(2) : 0;
};
const getCSVData = (packCalc) => {
    const secDetails = 'Details';
    const secDates = 'Dates';
    const secPrice = 'Price';
    const secNights = 'Nights';
    const secPeople = 'People';
    const secVat = 'VAT';
    const secCommission = 'Commission';
    const secInclusions = 'Inclusions';
    const secCalculation = 'Calculation';

    const rows = [
        ['Section', 'Label', 'Value', 'Pricing', 'Total'],
        [secDetails, 'Rate title', packCalc.rateTitle, '', ''],
        [secDetails, 'Rate description', packCalc.rateDescription, '', ''],
        [secDates, 'Valid from', dayjs(packCalc.validFrom).format('DD/MM/YYYY'), '', ''],
        [secDates, 'Valid to', dayjs(packCalc.validTo).format('DD/MM/YYYY'), '', ''],
        [secDates, 'Release date', dayjs(packCalc.releaseDate).format('DD/MM/YYYY'), '', ''],
        [secPrice, 'Proposed Selling Rate', packCalc.proposedRate, '', ''],
        [secNights, 'Number of nights', packCalc.numberOfNights, '', ''],
        [secPeople, 'Number of adults', packCalc.numberOfAdults, '', ''],
        [secPeople, 'Number of children', packCalc.numberOfChildren, '', ''],
        [secPeople, 'Number of infants', packCalc.numberOfInfants, '', ''],
        [secVat, 'VAT %', packCalc.vat, '', ''],
        [secCommission, 'Source', packCalc.commissionBrand, 'Percentage', packCalc.commissionPercentage],
    ];
    packCalc.inclusions.forEach((inclusion) =>
        rows.push([secInclusions, inclusion.name, inclusion.value, inclusion.pricePer, inclusion.amount]),
    );
    rows.push([
        secCalculation,
        'Cost of occupied room',
        packCalc.costOfOccupiedRoom,
        'perNight',
        packCalc.totalCostOfOccupiedRoom,
    ]);
    rows.push([secCalculation, 'Deductions', '', '', getTotalDeductions(packCalc)]);
    rows.push([secCalculation, 'Net Profit', '', '', packCalc.netProfit]);

    return rows;
};

export { getCSVData, getTotalDeductions };
